import React from 'react'
import PropTypes from 'prop-types'
import { getStrokeString } from '../Utils'
import {
  formatDate,
  formatDuration,
  formatNumber
} from '../Shared/detailFormat'
import { yearlyTotalsRows } from './memberFields'

// lapCount is keyed by stroke index; list the strokes that have laps.
const describeLapCounts = (lapCount) =>
  Object.entries(lapCount || {})
    .filter(([, count]) => count > 0)
    .sort((a, b) => b[1] - a[1])
    .map(([stroke, count]) => `${getStrokeString(stroke)} ${formatNumber(count, 0)}`)
    .join(' · ')

// UserInfo_v3.yearlyTotals_v9, one row per year.
const YearlyTotalsTableComponent = ({ yearlyTotals }) => {
  const rows = yearlyTotalsRows(yearlyTotals)
  if (rows.length === 0) {
    return <p className="text-muted mb-0">No yearly totals</p>
  }
  return (
    <div className="table-responsive">
      <table className="table table-sm mb-0">
        <thead>
          <tr>
            <th>Year</th>
            <th>Workouts</th>
            <th>Distance (m)</th>
            <th>Time</th>
            <th title="swolfFreestyleAverage">Free SWOLF</th>
            <th title="strokeCountPer25mFreestyleAvg">Free strokes /25m</th>
            <th title="currentStreak / longestStreak (weeks)">Streak now / best</th>
            <th>Last workout</th>
            <th>Laps by stroke</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.year}>
              <td><b>{row.year}</b></td>
              <td>{formatNumber(row.workoutCount, 0)}</td>
              <td>{formatNumber(row.distanceMeters, 0)}</td>
              <td>{formatDuration(row.durationSeconds)}</td>
              <td>{formatNumber(row.swolfFreestyleAverage, 1)}</td>
              <td>{formatNumber(row.strokeCountPer25mFreestyleAvg, 1)}</td>
              <td>{formatNumber(row.currentStreak, 0)} / {formatNumber(row.longestStreak, 0)}</td>
              <td>{formatDate(row.lastWorkoutDate)}</td>
              <td className="small">{describeLapCounts(row.lapCount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

YearlyTotalsTableComponent.propTypes = {
  yearlyTotals: PropTypes.object
}

export default YearlyTotalsTableComponent
